export const portalFunctionalityConstants = {
  "account": {
    "profile": 100,
    "account": 110,
    "customer": 120,
    "registered": 130
  },
  "management": {
    "order": 200,
    "service_number_type": 210,
    "invnumber": 220,
    "tariff": 230,
    "vendor": 240
  },
  "notification": {
    "notification": 400
  },
  "administration": {
    "account_type": 1000,
    "permission": 1010,
    "notification_type": 1020,
    "functionality": 1030
  },
  "support": {
    "support": 800
  },
  "report": {
    "report": 900
  },
  "documents": {
    "pdf": "application/pdf",
    "doc": "application/msword",
    "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "jpeg": "image/jpeg",
    "png": "image/png"
  }
}
